import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';

// Instructor Story 15: the attendance history across the courses the user teaches. The review requests on those sessions are the instructor's own
// Issue Queue (Admin Story 04, AC-19): the instructor of record resolves them there; anyone else who can open it reads them.
// The access refusal and the empty states are the pages' own, so a user who may not see an attendance reads the roster's message.
const meta = {
    title: 'Attendance History',
    breadcrumb: ['Attendance History'],
    dataTablePage: true,
};

export default [
    {
        path: '/attendance-history',
        name: 'attendance-history',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/courses/attendance/AttendanceHistory.vue'),
        meta,
    },
    {
        path: '/attendance-review-requests/:requestId(\\d+)?',
        name: 'attendance-review-requests',
        beforeEnter: FeatureMiddleware('ATTEND'),
        component: () => import('@/pages/attendance/InstructorIssueQueue.vue'),
        meta: { ...meta, title: 'Review requests', breadcrumb: ['Attendance History', 'Review requests'] },
    },
];
